import React, { useContext } from 'react'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

import { FnaContext } from '../../context'
import { ASSESSMENT_TYPE } from '../../reducer'
import { CardContent } from '../../../../components/layout/Card'
import { AssessmentCard } from './AssessmentCard'
import { DefaultAside } from '../../Components/Form/Aside'
import { R, sumCurrency } from '../../../../utils/currency'
import { totalRequirementRange } from '../../utils'

export const Index = () => {
  const {
    state: {
      fna,
    },
    actions: { goToNewForm, goToShow }
  } = useContext(FnaContext)

  const { lifeCoverAssessmentDetails, disabilityCoverAssessmentDetails, incomeProtectionAssessmentDetails } = getFnaAssessmentCardDetails(fna || {})


  return (
    <CardContent>
      <div className='block lg:grid lg:grid-cols-2'>
        <div>
          <AssessmentCard
            heading={`Life Cover`}
            items={lifeCoverAssessmentDetails}
            emptyStateMessage={`Life cover assessment is not yet completed.`}
            onCreate={goToNewForm(ASSESSMENT_TYPE.LIFE_COVER)}
            onShow={goToShow(ASSESSMENT_TYPE.LIFE_COVER)}
          />
          <AssessmentCard
            heading={`Disability Cover`}
            items={disabilityCoverAssessmentDetails}
            emptyStateMessage={`Disability cover assessment is not yet completed`}
            onCreate={goToNewForm(ASSESSMENT_TYPE.DISABILITY_COVER)}
            onShow={goToShow(ASSESSMENT_TYPE.DISABILITY_COVER)}
          />
          <AssessmentCard
            heading={`Income Protection`}
            items={incomeProtectionAssessmentDetails}
            emptyStateMessage={`Income protection assessment not yet completed.`}
            onCreate={goToNewForm(ASSESSMENT_TYPE.INCOME_PROTECTION)}
            onShow={goToShow(ASSESSMENT_TYPE.INCOME_PROTECTION)}
          />
        </div>
        <DefaultAside />
      </div>
    </CardContent>
  )
}

const getFnaAssessmentCardDetails = ({ lifeCover, disabilityCover, incomeProtection }) => {
  const lifeCoverBalance = R(get(lifeCover, 'balance', 0)).value
  const disabilityCoverBalance = R(get(disabilityCover, 'balance', 0)).value
  const incomeProtectionBalance = R(get(incomeProtection, 'balance', 0)).value

  const lifeCoverAssessmentDetails = !isEmpty(lifeCover) && {
    "Required cover": totalRequirementRange(lifeCover).riskProfile,
    "Current cover plus assets": R(get(lifeCover, 'total_provision')).format(),
    [lifeCoverBalance < 0 ? 'Shortfall' : 'Surplus']: R(lifeCoverBalance).format()
  }

  const disabilityCoverAssessmentDetails = !isEmpty(disabilityCover) && {
    "Required cover": R(get(disabilityCover, 'total_immediate_expenses', 0)).format(),
    "Existing cover": sumCurrency([get(disabilityCover, 'existing_cover', 0), get(disabilityCover, 'total_from_selected_risk_products', 0)]).format(),
    [disabilityCoverBalance < 0 ? 'Shortfall' : 'Surplus']: R(disabilityCoverBalance).format()
  }

  const incomeProtectionAssessmentDetails = !isEmpty(incomeProtection) && {
    "Required cover": R(get(incomeProtection, 'total_monthly_expenses', 0)).format(),
    "Existing cover": sumCurrency([get(incomeProtection, 'existing_cover', 0), get(incomeProtection, 'total_from_selected_risk_products', 0)]).format(),
    [incomeProtectionBalance < 0 ? 'Shortfall' : 'Surplus']: R(incomeProtectionBalance).format()
  }

  return {
    lifeCoverAssessmentDetails,
    disabilityCoverAssessmentDetails,
    incomeProtectionAssessmentDetails
  }
}
